import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { ConfigurationReference, getConf } from '@jbrowse/core/configuration';
import { InternetAccount } from '@jbrowse/core/pluggableElementTypes/models';
import { isElectron } from '@jbrowse/core/util';
import { types } from 'mobx-state-tree';
import jwtDecode from 'jwt-decode';
function fixup(buf) {
  return buf.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
var stateModelFactory = function stateModelFactory(configSchema) {
  return InternetAccount.named('OAuthInternetAccount').props({
    type: types.literal('OAuthInternetAccount'),
    configuration: ConfigurationReference(configSchema)
  }).views(function () {
    var codeVerifier = undefined;
    return {
      get codeVerifierPKCE() {
        if (codeVerifier) {
          return codeVerifier;
        }
        var array = new Uint8Array(32);
        globalThis.crypto.getRandomValues(array);
        codeVerifier = fixup(Buffer.from(array).toString('base64'));
        return codeVerifier;
      }
    };
  }).views(function (self) {
    return {
      get authEndpoint() {
        return getConf(self, 'authEndpoint');
      },
      get tokenEndpoint() {
        return getConf(self, 'tokenEndpoint');
      },
      get needsPKCE() {
        return getConf(self, 'needsPKCE');
      },
      get clientId() {
        return getConf(self, 'clientId');
      },
      get scopes() {
        return getConf(self, 'scopes');
      },
      /**
       * OAuth state parameter: https://www.rfc-editor.org/rfc/rfc6749#section-4.1.1
       * Can override or extend if dynamic state is needed.
       */
      state: function state() {
        return getConf(self, 'state') || undefined;
      },
      get responseType() {
        return getConf(self, 'responseType');
      },
      get hasRefreshToken() {
        return getConf(self, 'hasRefreshToken');
      },
      get refreshTokenKey() {
        return "".concat(self.internetAccountId, "-refreshToken");
      }
    };
  }).actions(function (self) {
    return {
      storeRefreshToken: function storeRefreshToken(refreshToken) {
        localStorage.setItem(self.refreshTokenKey, refreshToken);
      },
      removeRefreshToken: function removeRefreshToken() {
        localStorage.removeItem(self.refreshTokenKey);
      },
      retrieveRefreshToken: function retrieveRefreshToken() {
        return localStorage.getItem(self.refreshTokenKey);
      },
      exchangeAuthorizationForAccessToken: function () {
        var _exchangeAuthorizationForAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(token, redirectUri) {
          var data, params, response, errorMessage, accessToken;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                data = {
                  code: token,
                  grant_type: 'authorization_code',
                  client_id: self.clientId,
                  code_verifier: self.codeVerifierPKCE,
                  redirect_uri: redirectUri
                };
                params = new URLSearchParams(Object.entries(data));
                _context.next = 4;
                return fetch(self.tokenEndpoint, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  body: params.toString()
                });
              case 4:
                response = _context.sent;
                if (response.ok) {
                  _context.next = 16;
                  break;
                }
                _context.prev = 6;
                _context.next = 9;
                return response.text();
              case 9:
                errorMessage = _context.sent;
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                errorMessage = '';
              case 15:
                throw new Error("Failed to obtain token from endpoint: ".concat(response.status, " (").concat(response.statusText, ")").concat(errorMessage ? " (".concat(errorMessage, ")") : ''));
              case 16:
                _context.next = 18;
                return response.json();
              case 18:
                accessToken = _context.sent;
                if (accessToken.refresh_token) {
                  this.storeRefreshToken(accessToken.refresh_token);
                }
                return _context.abrupt("return", accessToken.access_token);
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[6, 12]]);
        }));
        function exchangeAuthorizationForAccessToken(_x, _x2) {
          return _exchangeAuthorizationForAccessToken.apply(this, arguments);
        }
        return exchangeAuthorizationForAccessToken;
      }(),
      exchangeRefreshForAccessToken: function () {
        var _exchangeRefreshForAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(refreshToken) {
          var _a, data, params, response, text, obj, accessToken;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  grant_type: 'refresh_token',
                  refresh_token: refreshToken,
                  client_id: self.clientId
                };
                params = new URLSearchParams(Object.entries(data));
                _context2.next = 4;
                return fetch(self.tokenEndpoint, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  body: params.toString()
                });
              case 4:
                response = _context2.sent;
                if (response.ok) {
                  _context2.next = 12;
                  break;
                }
                self.removeToken();
                _context2.next = 9;
                return response.text();
              case 9:
                text = _context2.sent;
                try {
                  obj = JSON.parse(text);
                  if (obj.error === 'invalid_grant') {
                    this.removeRefreshToken();
                  }
                  text = (_a = obj === null || obj === void 0 ? void 0 : obj.error_description) !== null && _a !== void 0 ? _a : text;
                } catch (e) {
                  /* just use original text as error */
                }
                throw new Error("Network response failure \u2014 ".concat(response.status, " (").concat(response.statusText, ") ").concat(text ? " (".concat(text, ")") : ''));
              case 12:
                _context2.next = 14;
                return response.json();
              case 14:
                accessToken = _context2.sent;
                if (accessToken.refresh_token) {
                  this.storeRefreshToken(accessToken.refresh_token);
                }
                return _context2.abrupt("return", accessToken.access_token);
              case 17:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function exchangeRefreshForAccessToken(_x3) {
          return _exchangeRefreshForAccessToken.apply(this, arguments);
        }
        return exchangeRefreshForAccessToken;
      }()
    };
  }).actions(function (self) {
    var listener;
    var refreshTokenPromise = undefined;
    return {
      // used to listen to child window for auth code/token
      addMessageChannel: function addMessageChannel(resolve, reject) {
        var _this = this;
        listener = function listener(event) {
          // this should probably get better handling, but ignored for now
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          _this.finishOAuthWindow(event, resolve, reject);
        };
        window.addEventListener('message', listener);
      },
      deleteMessageChannel: function deleteMessageChannel() {
        window.removeEventListener('message', listener);
      },
      finishOAuthWindow: function () {
        var _finishOAuthWindow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event, resolve, reject) {
          var redirectUriWithInfo, fixedQueryString, redirectUrl, queryStringSearch, urlParams, token, code, _token;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(event.data.name !== "JBrowseAuthWindow-".concat(self.internetAccountId))) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return", this.deleteMessageChannel());
              case 2:
                redirectUriWithInfo = event.data.redirectUri;
                fixedQueryString = redirectUriWithInfo.replace('#', '?');
                redirectUrl = new URL(fixedQueryString);
                queryStringSearch = redirectUrl.search;
                urlParams = new URLSearchParams(queryStringSearch);
                if (!urlParams.has('access_token')) {
                  _context3.next = 13;
                  break;
                }
                token = urlParams.get('access_token');
                if (token) {
                  _context3.next = 11;
                  break;
                }
                return _context3.abrupt("return", reject(new Error('Error with token endpoint')));
              case 11:
                self.storeToken(token);
                return _context3.abrupt("return", resolve(token));
              case 13:
                if (!urlParams.has('code')) {
                  _context3.next = 32;
                  break;
                }
                code = urlParams.get('code');
                if (code) {
                  _context3.next = 17;
                  break;
                }
                return _context3.abrupt("return", reject(new Error('Error with authorization endpoint')));
              case 17:
                _context3.prev = 17;
                _context3.next = 20;
                return self.exchangeAuthorizationForAccessToken(code, redirectUrl.origin + redirectUrl.pathname);
              case 20:
                _token = _context3.sent;
                self.storeToken(_token);
                return _context3.abrupt("return", resolve(_token));
              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3["catch"](17);
                if (!(_context3.t0 instanceof Error)) {
                  _context3.next = 31;
                  break;
                }
                return _context3.abrupt("return", reject(_context3.t0));
              case 31:
                return _context3.abrupt("return", reject(new Error(String(_context3.t0))));
              case 32:
                if (!redirectUriWithInfo.includes('access_denied')) {
                  _context3.next = 34;
                  break;
                }
                return _context3.abrupt("return", reject(new Error('OAuth flow was cancelled')));
              case 34:
                if (!redirectUriWithInfo.includes('error')) {
                  _context3.next = 36;
                  break;
                }
                return _context3.abrupt("return", reject(new Error('Oauth flow error: ' + queryStringSearch)));
              case 36:
                this.deleteMessageChannel();
              case 37:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this, [[17, 25]]);
        }));
        function finishOAuthWindow(_x4, _x5, _x6) {
          return _finishOAuthWindow.apply(this, arguments);
        }
        return finishOAuthWindow;
      }(),
      // opens external OAuth flow, popup for web and new browser window for desktop
      useEndpointForAuthorization: function () {
        var _useEndpointForAuthorization = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
          var redirectUri, data, codeVerifierPKCE, sha256, Base64, codeChallenge, params, url, eventName, _window$require, ipcRenderer, _redirectUri, eventFromDesktop, options;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                redirectUri = isElectron ? 'http://localhost/auth' : window.location.origin + window.location.pathname;
                data = {
                  client_id: self.clientId,
                  redirect_uri: redirectUri,
                  response_type: self.responseType || 'code'
                };
                if (self.state()) {
                  data.state = self.state();
                }
                if (self.scopes) {
                  data.scope = self.scopes;
                }
                if (!self.needsPKCE) {
                  _context4.next = 15;
                  break;
                }
                codeVerifierPKCE = self.codeVerifierPKCE;
                _context4.next = 8;
                return import('crypto-js/sha256').then(function (f) {
                  return f.default;
                });
              case 8:
                sha256 = _context4.sent;
                _context4.next = 11;
                return import('crypto-js/enc-base64');
              case 11:
                Base64 = _context4.sent;
                codeChallenge = fixup(Base64.stringify(sha256(codeVerifierPKCE)));
                data.code_challenge = codeChallenge;
                data.code_challenge_method = 'S256';
              case 15:
                if (self.hasRefreshToken) {
                  data.token_access_type = 'offline';
                }
                params = new URLSearchParams(Object.entries(data));
                url = new URL(self.authEndpoint);
                url.search = params.toString();
                eventName = "JBrowseAuthWindow-".concat(self.internetAccountId);
                if (!isElectron) {
                  _context4.next = 29;
                  break;
                }
                _window$require = window.require('electron'), ipcRenderer = _window$require.ipcRenderer;
                _context4.next = 24;
                return ipcRenderer.invoke('openAuthWindow', {
                  internetAccountId: self.internetAccountId,
                  data: data,
                  url: url.toString()
                });
              case 24:
                _redirectUri = _context4.sent;
                eventFromDesktop = new MessageEvent('message', {
                  data: {
                    name: eventName,
                    redirectUri: _redirectUri
                  }
                }); // may want to improve handling
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.finishOAuthWindow(eventFromDesktop, resolve, reject);
                _context4.next = 31;
                break;
              case 29:
                options = "width=500,height=600,left=0,top=0";
                window.open(url, eventName, options);
              case 31:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function useEndpointForAuthorization(_x7, _x8) {
          return _useEndpointForAuthorization.apply(this, arguments);
        }
        return useEndpointForAuthorization;
      }(),
      getTokenFromUser: function () {
        var _getTokenFromUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
          var refreshToken;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                refreshToken = self.hasRefreshToken && self.retrieveRefreshToken();
                if (!refreshToken) {
                  _context5.next = 7;
                  break;
                }
                _context5.t0 = resolve;
                _context5.next = 5;
                return self.exchangeRefreshForAccessToken(refreshToken);
              case 5:
                _context5.t1 = _context5.sent;
                (0, _context5.t0)(_context5.t1);
              case 7:
                this.addMessageChannel(resolve, reject);
                // may want to improve handling
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.useEndpointForAuthorization(resolve, reject);
              case 9:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function getTokenFromUser(_x9, _x10) {
          return _getTokenFromUser.apply(this, arguments);
        }
        return getTokenFromUser;
      }(),
      validateToken: function () {
        var _validateToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(token, location) {
          var decoded, refreshToken, newToken;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                decoded = jwtDecode(token);
                if (!(decoded.exp && decoded.exp < new Date().getTime() / 1000)) {
                  _context6.next = 17;
                  break;
                }
                refreshToken = self.hasRefreshToken && self.retrieveRefreshToken();
                if (!refreshToken) {
                  _context6.next = 15;
                  break;
                }
                _context6.prev = 4;
                if (!refreshTokenPromise) {
                  refreshTokenPromise = self.exchangeRefreshForAccessToken(refreshToken);
                }
                _context6.next = 8;
                return refreshTokenPromise;
              case 8:
                newToken = _context6.sent;
                return _context6.abrupt("return", this.validateToken(newToken, location));
              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](4);
                throw new Error("Token could not be refreshed. ".concat(_context6.t0));
              case 15:
                _context6.next = 18;
                break;
              case 17:
                refreshTokenPromise = undefined;
              case 18:
                return _context6.abrupt("return", token);
              case 19:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this, [[4, 12]]);
        }));
        function validateToken(_x11, _x12) {
          return _validateToken.apply(this, arguments);
        }
        return validateToken;
      }()
    };
  });
};
export default stateModelFactory;